@if (contentTemplate || text) {
  <div class="Tooltip" [class]="{ Tooltip__top: showAbove, Tooltip__bottom: !showAbove }">
    <div class="Tooltip__container">
      <ng-template #simpleText> {{ text }} </ng-template>
      <ng-container [ngTemplateOutlet]="contentTemplate || simpleText"
        [ngTemplateOutletContext]="templateData" />
    </div>
  </div>
}
